import ReactDOM from 'react-dom/client';
import React from 'react';
import { ProductPricingTable } from './product-pricing-table';
import { TenantContext } from '../../context/tenant-context';
import { v2Component } from '../../index';

export function initProductPricingTable() {
  document.getElementsByName('product-pricing-table').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, productId, locationId, ...props } = Object.assign({}, element.dataset) as any;
      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <ProductPricingTable productId={productId} locationId={locationId} {...props} />
          </TenantContext.Provider>,
        ),
      );

      const event = new CustomEvent('change');
      element.dispatchEvent(event);
    }
  });
}
